import React, { FunctionComponent } from 'react';
import { Divider, Typography } from '@material-ui/core';
import summaryStyles from './summarySection/SummaryStyles';
import LabelAndPrice from './labels/LabelAndPrice';
import SummaryBasketTotalPrice from './summaryTotalPrice/SummaryBasketTotalPrice';
import Translation from '../../../../../common/components/translation/Translation';

export interface ITradeInSectionProps {
  loading?: boolean;
  tradeInValue: number;
  tradeInCar: string;
  tradeInManufactureYear: number;
  currency: string;
  totalAmountPayable: number;
}

const TradeInSection: FunctionComponent<ITradeInSectionProps> = ({
  tradeInValue,
  tradeInCar,
  currency,
  totalAmountPayable,
  tradeInManufactureYear,
  loading,
}) => {
  const styles = summaryStyles();

  return (
    <>
      <Divider />
      <LabelAndPrice
        label={<Translation id={'spc.customise.equity'} />}
        price={tradeInValue}
        priceType="tradeIn"
        currency={currency}
        showSign={tradeInValue > 0}
        boldPrice={'normal'}
      />
      <Typography variant={'caption'} className={styles.tradeInCar} data-test="configure:summary:tradeInDescription">
        {`${tradeInManufactureYear} ${tradeInCar}`}
      </Typography>
      <Divider />
      <SummaryBasketTotalPrice loading={loading} totalWithOptions={totalAmountPayable} currency={currency} />
    </>
  );
};

export default TradeInSection;
